import wallpaper from "./Images/wallpaper.png";



export default function Logo() {
    return (<div className="divparceiros"><div className="divwallpaper"><img className="wallpaper" src={wallpaper}></img></div><div className="parceiroswidth"><h2 className="parceirostext">Nosso corpo técnico possui vasto acervo e <strong className="strong">expertise</strong> que abrange todas as etapas do ciclo <strong className="strong">construtivo</strong>, da incorporação à execução, com tecnologia de ponta, práticas <strong className="strong">sustentáveis</strong> e uma equipe altamente qualificada.</h2></div>
        <div className="divinformation">
            <div className="parceirosdescription"> <div className="descripcolumn"><h2 className="description">15K<strong className="gold">+</strong></h2><h2 className="subdescription">Unidades habitacionais</h2></div></div>

            <div className="parceirosdescription"><div className="descripcolumn"> <h2 className="description">R$2.2B<strong className="gold">+</strong></h2><h2 className="subdescription">Em VGV</h2></div></div>
            <div className="parceirosdescription"><div className="descripcolumn"> <h2 className="description">800K<strong className="gold">+</strong></h2><h2 className="subdescription">Metros quadrados construídos</h2></div></div>

        </div>
    </div>
    )
}
